var VCA = VCA || {};

VCA.NewsLetterCTA = (function ($) {

    var ui = {};

    function cacheUI() {
        ui.$signUpBtn = $('.js-newsletter-signup-btn');
        ui.$newsLetterForm = $('.js-newsletter-form');
        ui.$newsThankYou = $('.js-newsletter-thankyou');
        ui.$newserror = $('.js-newsletter-error');
        ui.submitBtn =$('.js-submit-btn');
    }

    function init() {
        if ($('.js-newsletter-signup').length <= 0) {
            return;
        }
        cacheUI();
        bindSignUpClick();
        bindSubmitClick();
    }

    function bindSignUpClick() {
        ui.$signUpBtn.on('click', function (e) {
            e.preventDefault();
            let mailFormat = /(^[a-zA-Z0-9_.]+[@]{1}[a-zA-Z0-9\-]+[\.][a-zA-Z]+$)/;
            let item = $(this).closest('.js-newsletter-signup');
            let email = item.find('.js-newsletter-signup-input').val();
            console.log(email);
            if (!mailFormat.test(email)) {
                item.addClass('input-validation-error');
               // el.closest('.form-label-group').addClass('error');
               item.find('.js-newsletter-signup-input').triggerHandler( "focus" );
                return
            } else {
                item.removeClass('input-validation-error');
                $('#Newsletter').modal('show');
                $('#Newsletter').find('input.newsletter-signup-email-field').val(email);
            }
        });
    }

    function bindSubmitClick() {
        ui.submitBtn.on('click', function (e) {
            ui.$newsLetterForm.hide();
            ui.$newsThankYou.show();
        });
    }

    return {
       init: init
    };

})(jQuery);

$(function () {
    VCA.NewsLetterCTA.init();
});